import { AlertCircle, RefreshCw } from "lucide-react";

// Banner for a data request that failed for a reason other than "backend
// unreachable" — that one case is already covered by useApiData's `demo` flag
// and the amber "Showing demo data" strip each page renders.
//
// Without this the admin pages dropped useApiData's `error` on the floor: a 500,
// a 403, or the client's "expected JSON" guard left `data` null and the table
// rendered its ordinary empty state, so a failed load was indistinguishable from
// a genuinely empty account. Callers should also suppress their empty state
// while `error` is set, so the two never contradict each other.
export default function LoadError({ message, onRetry, className = "" }) {
  if (!message) return null;
  return (
    <div
      role="alert"
      className={`mb-5 flex items-center gap-2 rounded-xl border border-rose-200 bg-rose-50/70 px-4 py-2.5 text-sm text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-200 ${className}`}
    >
      <AlertCircle size={15} className="shrink-0" />
      <span className="flex-1">{message}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-rose-300 px-2 py-1 text-xs font-medium transition-colors hover:bg-rose-100 dark:border-rose-500/30 dark:hover:bg-rose-500/10"
        >
          <RefreshCw size={12} /> Retry
        </button>
      )}
    </div>
  );
}
